export const SET_NOTA_BIMESTRE_TIPO = 'SET_NOTA_BIMESTRE_TIPO'